let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("idYq2")).then(() => parcelRequire('6uDk4'));